import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton } from '../../../shared/uiComponents';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { RED } from '../../../shared/Helpers/colors';
import { TrashEmpty } from '../../../shared/Assets/sessionDetailsSVGs';
import { ButtonWrapper } from '../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { deleteUserSessionAllocation } from '../../../redux/State/userSlice';

const DeleteAllocation = ({ onClose, allocationId }: { allocationId: string | null; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const [open, setOpen] = useState(false);

	const handleDelete = () => {
		if (!allocationId) return;
		dispatch(deleteUserSessionAllocation(allocationId))
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				onClose();
			})
			.catch(errorNormalizer);
	};

	const isDeleting = useSelector((state) => state.userSessionAllocation.isDeleting);

	return (
		<>
			<CustomButton
				title="Delete"
				onClick={() => setOpen(true)}
				buttonType="secondary"
				style={{ backgroundColor: RED.QUATERNARY, color: RED.BASE }}
				startIcon={<TrashEmpty color={RED.BASE} />}
			/>
			<CustomAlert
				isBusy={isDeleting}
				open={open}
				onClose={() => setOpen(false)}
				title="Are you sure?"
				Content={() => (
					<ButtonWrapper>
						<CustomButton
							title="Delete"
							onClick={handleDelete}
							buttonType="secondary"
							style={{ backgroundColor: RED.QUATERNARY, color: RED.BASE }}
							startIcon={<TrashEmpty color={RED.BASE} />}
						/>
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpen(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default DeleteAllocation;
